<!-- version 2021/05/20 -->
<template>
    <img :src="imageurl">
</template>

<script>
    export default {
        props: {
            imageurl: String
        }
    }
</script>

<style lang="sass" scoped>
    img
        width: 100%
</style>